import React from "react";
import Layout from "../../components/Layout/layout";
import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import pdfFile from "../../assets/Sponsorship_Prospectus_8ICRAGEE.pdf";
import "@react-pdf-viewer/core/lib/styles/index.css";

const Sponsors = () => {
  return (
    <Layout>
      <main className="bg-gray-100 mt-[10vw]">
        <div className="flex absolute md:mt-[-20vw] mt-[-15vw] md:flex-row flex-col items-center w-full justify-center gap-12">
          <div
            className="text-[55px] text-white"
            style={{ fontFamily: "Bebas Neue", textShadow: "2px 1px 0px #000" }}
          >
            SPONSORSHIP
          </div>
        </div>
      </main>
      <div className="bg-[#D7DDE1] py-10">
        <div className="w-full md:w-3/4 px-10 md:px-20 py-8 border-2 bg-white z-20 mb-[5vh] relative mx-auto">
          <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js">
            <div className="h-[80vh]">
              <Viewer fileUrl={pdfFile} />
            </div>
          </Worker>
          <div className="mt-[2rem] ml-[3rem]">
            <a
              href={pdfFile}
              download={pdfFile}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded "
            >
              Download PDF
            </a>
          </div>
        </div>
        <div className="w-full md:w-3/4 px-10 md:px-20  py-16 border-2 bg-white  z-20 mb-[-10vh] relative  mx-auto">
          <div className="font-bold text-4xl text-[#1F7E95] mb-10">
            INVITATION TO SPONSORS
          </div>
          <div className="font-medium text-xl mb-10">
            Industries, Instrument Manufacturers, Builders, Contractors,
            Consultants, Institutions and other agencies are invited to
            generously sponsor the event.
          </div>

          <div>
            <table className="text-2xl">
              <tr>
                <td className="border-b-2 border-orange-400 border-t-2 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Platinum Sponsors
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 border-t-2 px-8 py-4">
                  INR 8.0 Lakh
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Diamond Sponsors{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4 md:pr-48">
                  INR 5.0 Lakh{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Gold Sponsors
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  INR 3.0 Lakh{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Silver Sponsors
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  INR 2.0 Lakh{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Sponsor
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  INR 1.0 Lakh{" "}
                </td>
              </tr>
            </table>
          </div>

          <div className="font-medium text-xl mb-5 mt-10">
            For Sponsorship, please contact us at :
          </div>
          <div className="font-medium text-xl ">
            Email ID: 8icragee@iitg.ac.in
          </div>
        </div>
        <div className="bg-orange-600 h-[35vh] text-white z-10  "></div>
        {/* <div className="w-3/4 px-20 py-20 border-2  bg-white z-20 mt-[-10vh] relative  mx-auto  ">
          <div className="font-bold text-4xl text-[#1F7E95] mb-10">
            BANK ACCOUNT DETAILS
          </div>

          <div>
            <table className="">
              <tr>
                <td className="border-b-2 border-orange-400 border-t-2 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    BANK NAME
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 border-t-2 px-8 py-4">
                  State Bank of India{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Account Name{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4 md:pr-48">
                  Indian Institute of Technology Guwahati{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Account Number{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  8738 3278 2323{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    IFSC Code{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  SBI0000123{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Branch Name{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  Sector 15, Assam, Guwahati{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    UPI ID{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  IITG@SBI{" "}
                </td>
              </tr>
            </table>
          </div>
        </div> */}
      </div>
    </Layout>
  );
};

export default Sponsors;
